import {Box, HBox} from '../../core/view';
import {Dimensions, StyleSheet} from 'react-native';
import React, {useCallback, useEffect, useState} from 'react';
import {TabData, TabProps} from './type';

import {CustomFlatList} from '@buncha/components/core/list';
import If from '@buncha/components/conditional/If';
import {Touchable} from '../../core/touchable';

const Tab: React.FC<TabProps> = props => {
  const colorThemeType = props.colorThemeType || 'default';
  const [activeKey, setActiveKey] = useState(props.tabData[0].key);
  const isActiveSeactionPresent = activeKey in (props.sections || {});
  const [isScrollable, setIsScrollable] = useState(false);
  const screenWidth = Dimensions.get('window').width;

  const handleContentSizeChange = useCallback(
    (contentWidth: number) => {
      if (contentWidth > screenWidth - 30) setIsScrollable(true);
      else setIsScrollable(false);
    },
    [screenWidth],
  );

  const renderItem = useCallback(
    (item: TabData<any>) => {
      const touchableStyle = [
        styles.touchable,
        {paddingHorizontal: props?.isScrollable ? 10 : 0},
      ];
      return (
        <Touchable
          style={touchableStyle}
          key={item.key}
          onPress={() => {
            if (props.getActiveKey) props.getActiveKey(item);
            setActiveKey(item.key);
            props?.setActiveKey?.(item.key);
          }}>
          {props.tabNode(item, activeKey)}
        </Touchable>
      );
    },
    [activeKey, props],
  );

  useEffect(() => {
    if (props.activeKey) setActiveKey(props.activeKey);
  }, [props.activeKey]);

  return (
    <Box {...props} colorThemeType={colorThemeType} style={styles.parentBox}>
      <If condition={!props?.isScrollable}>
        <HBox style={styles.horizontalBox}>
          {props?.tabData?.map(item => {
            return renderItem(item);
          })}
        </HBox>
      </If>
      <If condition={props?.isScrollable}>
        <CustomFlatList
          horizontal={true}
          scrollEnabled={isScrollable}
          data={props?.tabData}
          renderItem={({item}) => renderItem(item)}
          style={styles.flatList}
          showsHorizontalScrollIndicator={false}
          onContentSizeChange={contentWidth =>
            handleContentSizeChange(contentWidth)
          }
        />
      </If>
      {isActiveSeactionPresent && props.sections[activeKey]}
    </Box>
  );
};

export default React.memo(Tab);

const styles = StyleSheet.create({
  parentBox: {
    flex: 1,
    width: '100%',
  },
  horizontalBox: {
    height: 40,
    // paddingHorizontal: 10,
    zIndex: 1,
  },
  touchable: {
    width: '100%',
    flex: 1,
  },
  flatList: {height: 40},
});
